module.exports = __webpack_public_path__ + "assets/pride-logo-3cce96.svg";